export const getFilteredPartnerIds = (value: string) => {
  const splittedValues = value.split(/\s|,|\.|, /g)
  return splittedValues.filter((el) => el && /^[a-zA-Z0-9-]+$/g.test(el))
}
